import styled, { css, keyframes } from 'styled-components'

const slideIn = keyframes`
  from {
    opacity: 0.5;
    transform: translateX(-1%);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`

const Steps = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(10px, 1fr));
  gap: 5px;
  margin: 16px 0;
  padding: 8px 0 16px;
`

const Step = styled.div<{ selected: boolean }>`
  height: 4px;
  background-color: ${({ selected, theme }) =>
    selected
      ? theme.colors.common.accentMedium
      : theme.colors.common.backgroundMedium};
  border-radius: 17px;

  ${({ selected }) =>
    selected &&
    css`
      animation: ${slideIn} 0.6s ease-out;
    `}
`

type StepperProps = {
  total: number
  step: number
}

export const Stepper = ({ step, total }: StepperProps) => {
  return (
    <Steps>
      {new Array(total).fill(null).map((_, index) => {
        return <Step key={index} selected={index <= step} />
      })}
    </Steps>
  )
}
